<template>
  <div class="edit">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
            <v-card-title class="title grey lighten-2" primary-title>Edit Godaddy Account</v-card-title>

            <v-card-text class="pt-3">
              
              <v-form ref="form" v-model="valid">

                <v-text-field v-model="fullname" :rules="nameRules" label="Full Name (*)" required></v-text-field>

                <v-text-field v-model="loginID" :rules="nameRules" label="Login ID (*)" required></v-text-field>

                <v-text-field v-model="password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required]"
                    :type="show ? 'text' : 'password'"
                    label="Password (*)"
                    @click:append="show = !show"
                    required
                ></v-text-field>

                <v-text-field v-model="email" :rules="emailRules" label="E-mail (*)" required></v-text-field>

                <v-text-field v-model="domainName" :rules="nameRules" label="Domain Name (*)" required></v-text-field>

                <v-textarea v-model="remark" outlined label="Remark (Optional)"></v-textarea>

              </v-form>

            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-btn dark @click="$emit('dialogHide')">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey white--text" :loading="isLoading" :disabled="!valid" @click="updateRecord">Save Update</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
import { db, auth } from '@/plugins/appfirebase'
export default {

  props: [ 'dialog', 'recuid' ],

  created() {
    this.getRecord()
  },

  data() {
    return {

      fullname: '',
      loginID: '',
      email: '',
      password: '',
      domainName: '',
      remark: '',

      nameRules: [
        v => !!v || 'Name is required',
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      rules: {
          required: value => !!value || 'Required.'
      },
      valid: true,
      show: false,
      isLoading: false,
      
      mydb: db.collection('godaddy').doc(auth.currentUser.uid).collection('data')
    }
  },

  methods: {

    getRecord() {

      if (this.recuid) {
        
        this.mydb.doc(this.recuid).get()
          .then( docs => {

            let doc = docs.data();

            this.fullname = doc.fullname,
            this.loginID = doc.login_id,
            this.email = doc.email,
            this.password = doc.password,
            this.domainName = doc.domain_name,
            this.remark = doc.remark
          })
      }
      
    },

    updateRecord() {
      
      this.isLoading = true

      this.mydb.doc(this.recuid)
        .update({
          fullname: this.fullname,
          login_id: this.loginID,
          email: this.email,
          password: this.password,
          domain_name: this.domainName,
          remark: this.remark
        })
        .then( () => {
          this.isLoading = false
          this.$store.state.snackSuccess = true
          this.$emit('dialogHide');
        })
    }

  },

}
</script>

<style>

</style>